import { render, staticRenderFns } from "./DevPageKD3.vue?vue&type=template&id=1bcdaa1a&scoped=true"
import script from "./DevPageKD3.vue?vue&type=script&lang=js"
export * from "./DevPageKD3.vue?vue&type=script&lang=js"
import style0 from "./DevPageKD3.vue?vue&type=style&index=0&id=1bcdaa1a&prod&lang=css"
import style1 from "./DevPageKD3.vue?vue&type=style&index=1&id=1bcdaa1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcdaa1a",
  null
  
)

export default component.exports